import { useState, useMemo } from "react";
function useEditState({ savedValue, onChange }) {
  const [editMode, setEditMode] = useState(false);
  const [formValue, setFormValue] = useState(savedValue);
  return useMemo(
    () => ({
      value: editMode ? formValue : savedValue,
      editMode,
      setValue: (val) => {
        if (editMode) {
          setFormValue(val);
        }
      },
      beginEdit: () => {
        if (!editMode) {
          setFormValue(savedValue);
          setEditMode(true);
        }
      },
      commitEdit: () => {
        if (editMode) {
          if (formValue !== savedValue && onChange) {
            onChange(formValue);
          }
          setEditMode(false);
        }
      },
      cancelEdit: () => {
        if (editMode) {
          setFormValue(savedValue);
          setEditMode(false);
        }
      }
    }),
    [savedValue, editMode, formValue, onChange]
  );
}
export {
  useEditState
};
